import * as React from "react";
import { RadioContainer, RadioInformation } from "./radio-component";

type Props = {
  className?: string;
  key?: any;
  name: string;
  id: any;
  register?: any;
  value: any;
  checked?: boolean;
  label: string;
  disable?: boolean;
  text?: string;
};

export default function Textarea({
  className,
  key,
  name,
  id,
  register,
  value,
  checked,
  label,
  disable,
  text,
}: Props) {
  return (
    <RadioContainer className={className} key={key}>
      <input
        type="radio"
        name={name}
        id={id}
        ref={register}
        value={value}
        defaultChecked={checked}
        disabled={disable}
      />
      <label htmlFor={id}>{label}</label>
      {text && <RadioInformation>{text}</RadioInformation>}
    </RadioContainer>
  );
}
